import RangePickerSystem from './RangePickerSystem';
import './RangePickerSystem.scss';

export default RangePickerSystem;
